import React from "react";
import makeStyles from '@mui/styles/makeStyles';
import { Card } from "@mui/material";

const useStyles = makeStyles(() => ({
  cardcontent: {
    padding: 10,
    "&:last-child": {
      paddingBottom: 8,
    },
  },
}));

export default function TightCardContent(props) {
  const classes = useStyles();

  return <Card className={classes.cardcontent} {...props} />;
}
